import Registry, { ComponentFactoryRegistry } from 'live/services/registry'
import DefaultAnnotation from './annotations/default-annotation'

export const AnnotationExportRegistry = new Registry<AnnotationExportRegistryConfigObj>()
export const TimelineEventRendererRegistry = new ComponentFactoryRegistry(DefaultAnnotation)
export const TimelineFormRegistry = new Registry()
